import * as React from 'react';
import API, { GenericAddResponse } from "../../common/API";
import { useAuth } from "react-oidc-context";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ErrorModalComponent } from '../../components/shared/ErrorModalComponent';

interface AddLinkedServerRequest {
    name: string | undefined
}

export function LinkedServerAddComponent() {
    const auth = useAuth();
    const navigate = useNavigate()

    const [name, setName] = React.useState<string>();

    const [errorMsg, setErrorMsg] = React.useState<string | undefined>();

    const addServer = async (e: React.SyntheticEvent<HTMLFormElement>) => {
        e.preventDefault();

        const req: AddLinkedServerRequest = {
            name: name
        };

        try {
            const res: GenericAddResponse | null = await API.post("/api/v1/linkedServer", req, auth);

            if (res !== null)
                navigate("/deployment/" + res.id);

        } catch (e) {
            if (API.isErrorResponse(e)) {
                if (e.errors.hasOwnProperty('Error')) {
                    setErrorMsg(e.errors['Error']);
                } else {
                    setErrorMsg(e.title as string)
                }
            }
            console.log(e);
        }
    }


    return (
        <div>
            <ErrorModalComponent errorMessage={errorMsg} onHide={() => setErrorMsg(undefined)} />
            <div className="d-flex justify-content-between mb-3">
                <h1 className="header-text">
                    <FontAwesomeIcon icon="server" className="fs-3 me-2" />
                    Add Linked Server
                </h1>
            </div>

            <div className="card col-6">
                <div className="card-header d-flex justify-content-between align-items-center">
                    <h5 className="card-title mb-0">Server</h5>
                </div>
                <div className="card-body">
                    <form onSubmit={addServer}>
                        <p>Enter a name that will be used to reference the linked server.</p>
                        <div className="form-group row">
                            <label className="col-form-label col-sm-2">Name</label>
                            <div className="col-sm-6">
                                <input className="form-control" onChange={(e) => setName(e.target.value)} />
                            </div>
                        </div>

                        <div className="text-end">
                            <button type="submit" className="btn btn-primary">
                                <FontAwesomeIcon icon="check" />
                                Add
                            </button>
                        </div>
                    </form>
                </div>
            </div>

        </div>
    )
}